export enum SearchKeys {
  IMEI = "IMEI",
  Phone = "Phone",
  CertificateNumber = "CertificateNumber"
}
